import { Button } from "./ui/button";
import { Zap, Check } from "lucide-react";

const usd = (v) => `$${Number(v || 0).toFixed(2)}`;

export const DriverKits = ({ kits, onBuy }) => {
  if (!kits?.length) return null;
  return (
    <section className="space-y-4" data-testid="driver-kits">
      <div className="space-y-1">
        <p className="font-mono text-xs tracking-widest uppercase text-cyan-400 flex items-center gap-1.5"><Zap className="w-3.5 h-3.5" />// Driver kits · one-tap bundles</p>
        <h2 className="font-display text-base md:text-lg font-bold text-slate-200">Curated starter kits for gig drivers</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {kits.map((k, i) => {
          const save = k.retail_value > k.price ? k.retail_value - k.price : 0;
          return (
            <div key={k.product_id} className="relative rounded-2xl border border-cyan-400/20 bg-gradient-to-b from-[#141a26] to-[#0f1219] overflow-hidden flex flex-col animate-in fade-in slide-in-from-bottom-2" style={{ animationDelay: `${i * 80}ms` }} data-testid={`kit-${k.product_id}`}>
              <div className="aspect-[16/10] bg-[#0B0D12] overflow-hidden">{k.images?.[0] && <img src={k.images[0]} alt={k.name} className="w-full h-full object-cover" />}</div>
              {save > 0 && <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-cyan-400 text-slate-950 text-[10px] font-bold font-mono uppercase tracking-widest" data-testid={`kit-save-${k.product_id}`}>Save {usd(save)}</span>}
              <div className="p-5 flex-1 flex flex-col gap-3">
                <div><p className="font-display font-extrabold text-lg">{k.name}</p><p className="text-xs text-slate-400">{k.description}</p></div>
                <ul className="space-y-1 text-xs text-slate-300">{(k.bundle_items || []).map((b) => <li key={b.product_id} className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-cyan-400 shrink-0" />{b.name}</li>)}</ul>
                <div className="mt-auto flex items-end justify-between pt-2">
                  <div><p className="font-display font-extrabold text-2xl">{usd(k.price)}</p>{k.retail_value > k.price && <p className="text-[11px] text-slate-500 line-through font-mono">{usd(k.retail_value)} separately</p>}</div>
                  <Button disabled={k.sold_out} onClick={() => onBuy(k)} className="bg-cyan-400 text-slate-950 hover:bg-cyan-300 font-semibold rounded-full px-5" data-testid={`kit-buy-${k.product_id}`}><Zap className="w-4 h-4 mr-1" />{k.sold_out ? "Sold out" : "Buy kit"}</Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
